/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Diet_MacrosInputs */

const en_for_whom_diet_macros = /** @type {(inputs: For_Whom_Diet_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P 150 g · C 260 g · F 70 g`)
};

const pl_for_whom_diet_macros = /** @type {(inputs: For_Whom_Diet_MacrosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B 150 g · W 260 g · T 70 g`)
};

/**
* | output |
* | --- |
* | "P 150 g · C 260 g · F 70 g" |
*
* @param {For_Whom_Diet_MacrosInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_diet_macros = /** @type {((inputs?: For_Whom_Diet_MacrosInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Diet_MacrosInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_diet_macros(inputs)
	return en_for_whom_diet_macros(inputs)
});